/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddressDto {
  addressAddition?: string;
  city?: string;
  houseNumber?: string;
  postcode?: string;
  street?: string;
}

export interface AuditInfoDto {
  /** @example "system" */
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @example "system" */
  lastModifiedBy?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /**
   * @format int64
   * @example 1
   */
  version?: number;
}

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
}

/** Verfügbare Dokumentenarten */
export enum DocumentTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  ENVELOPE = "ENVELOPE",
  COVER_LETTER = "COVER_LETTER",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface ReceiverDto {
  address?: AddressDto;
  namePrimary?: string;
  nameSecondary?: string;
}

export interface ResourceCreatedDto {
  /** @format uuid */
  id?: string;
}

export interface ScanDocumentApplicationEvent {
  /** @format uuid */
  payload: string;
}

export interface ScanDocumentArchiveBatchDto {
  /**
   * @minLength 1
   * @maxItems 2147483647
   * @minItems 1
   */
  items: ScanDocumentArchiveBatchItemDto[];
  /** @format uuid */
  requestId: string;
}

/** @minLength 1 */
export interface ScanDocumentArchiveBatchItemDto {
  /**
   * Id of scanned document
   * @format uuid
   */
  scanDocumentId: string;
  /**
   * Current version of scanned document
   * @format int64
   */
  version: number;
}

export interface ScanDocumentArchivedServiceEvent {
  payload: ScanDocumentArchivedSocketEventDto;
}

export interface ScanDocumentArchivedSocketEventDto {
  /** @format uuid */
  requestId: string;
  /** @format uuid */
  scanDocumentId: string;
  successful: boolean;
}

export interface ScanDocumentCreateAbeDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "ABE" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateCertDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "CERT" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateCocDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "COC" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateContractDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "CONTRACT" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateCor1Dto {
  /**
   * ZB1 Nummer
   * @minLength 1
   * @pattern ^[A-Z][0-9A-ZÄÖÜ\-/]{17,19}$
   */
  corSerial: string;
  /** @format uuid */
  customerId: string;
  /**
   * Abmeldedatum
   * @format date
   */
  deregistrationDate?: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /** aktuelles Kennzeichen (keine Pflicht- da bei Neufahrzeugen nicht gefüllt) */
  licensePlate?: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  /**
   * Erstzulassungsdatum (keine Pflicht- da bei Neufahrzeugen nicht gefüllt)
   * @format date
   */
  registrationDateFirst?: string;
  /**
   * aktuelles Zulassungsdatum (keine Pflicht- da nicht immer gefüllt)
   * @format date
   */
  registrationDateLatest?: string;
  status: ScanRecordStatusDto;
  /** @default "COR_I" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
  /**
   * Prüfziffer der Fin
   * @minLength 1
   * @pattern ^[0-9X\-/]$
   */
  vinCheckDigit: string;
}

export interface ScanDocumentCreateCor2Dto {
  /**
   * ZB2 Nummer
   * @minLength 1
   * @pattern ^[A-Z]{2}[0-9]{6}$
   */
  corNumber: string;
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /** aktuelles Kennzeichen (keine Pflicht- da bei Neufahrzeugen nicht gefüllt) */
  licensePlate?: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  /**
   * Erstzulassungsdatum (keine Pflicht- da bei Neufahrzeugen nicht gefüllt)
   * @format date
   */
  registrationDateFirst?: string;
  /**
   * aktuelles Zulassungsdatum (keine Pflicht- da nicht immer gefüllt)
   * @format date
   */
  registrationDateLatest?: string;
  status: ScanRecordStatusDto;
  /** @default "COR_II" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
  /**
   * Prüfziffer der Fin
   * @minLength 1
   * @pattern ^[0-9X\-/]$
   */
  vinCheckDigit: string;
}

export interface ScanDocumentCreateCoverLetterDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  receiver: ReceiverDto;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "COVER_LETTER" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export type ScanDocumentCreateDto = BaseScanDocumentCreateDto &
  (
    | BaseScanDocumentCreateDtoTypeMapping<"ABE", ScanDocumentCreateAbeDto>
    | BaseScanDocumentCreateDtoTypeMapping<"CERT", ScanDocumentCreateCertDto>
    | BaseScanDocumentCreateDtoTypeMapping<"COC", ScanDocumentCreateCocDto>
    | BaseScanDocumentCreateDtoTypeMapping<"CONTRACT", ScanDocumentCreateContractDto>
    | BaseScanDocumentCreateDtoTypeMapping<"COR_I", ScanDocumentCreateCor1Dto>
    | BaseScanDocumentCreateDtoTypeMapping<"COR_II", ScanDocumentCreateCor2Dto>
    | BaseScanDocumentCreateDtoTypeMapping<"COVER_LETTER", ScanDocumentCreateCoverLetterDto>
    | BaseScanDocumentCreateDtoTypeMapping<"ENVELOPE", ScanDocumentCreateEnvelopeDto>
    | BaseScanDocumentCreateDtoTypeMapping<"ID_CARD", ScanDocumentCreateIdCardDto>
    | BaseScanDocumentCreateDtoTypeMapping<"OTHER", ScanDocumentCreateOtherDto>
    | BaseScanDocumentCreateDtoTypeMapping<"SALARY_STATEMENT", ScanDocumentCreateSalaryStatementDto>
  );

export interface ScanDocumentCreateEnvelopeDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  receiver: ReceiverDto;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "ENVELOPE" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateIdCardDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "ID_CARD" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateOtherDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "OTHER" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentCreateSalaryStatementDto {
  /** @format uuid */
  customerId: string;
  /**
   * Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId.
   * @minLength 1
   */
  documentId: string;
  /**
   * @format int64
   * @min 0
   */
  position: number;
  /**
   * For manually create scan documents the stack id is always the same as the record id.
   * @minLength 1
   */
  recordId: string;
  status: ScanRecordStatusDto;
  /** @default "SALARY_STATEMENT" */
  type?: string;
  /**
   * Vehicle Identification Number
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ScanDocumentDataAbeDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "ABE" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataCertDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "CERT" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataCocDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "COC" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataContractDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "CONTRACT" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataCor1Dto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** @format date */
  dateOfDeRegistration?: string;
  /** @format date */
  dateOfRegistration?: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /** @format date */
  firstDateOfRegistration?: string;
  licensePlate?: string;
  number?: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "COR_I" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataCor2Dto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** @format date */
  dateOfRegistration?: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /** @format date */
  firstDateOfRegistration?: string;
  licensePlate?: string;
  number?: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "COR_II" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataCoverLetterDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  receiver?: ReceiverDto;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "COVER_LETTER" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export type ScanDocumentDataDto = BaseScanDocumentDataDto &
  (
    | BaseScanDocumentDataDtoTypeMapping<"ABE", ScanDocumentDataAbeDto>
    | BaseScanDocumentDataDtoTypeMapping<"CERT", ScanDocumentDataCertDto>
    | BaseScanDocumentDataDtoTypeMapping<"COC", ScanDocumentDataCocDto>
    | BaseScanDocumentDataDtoTypeMapping<"CONTRACT", ScanDocumentDataContractDto>
    | BaseScanDocumentDataDtoTypeMapping<"COR_I", ScanDocumentDataCor1Dto>
    | BaseScanDocumentDataDtoTypeMapping<"COR_II", ScanDocumentDataCor2Dto>
    | BaseScanDocumentDataDtoTypeMapping<"COVER_LETTER", ScanDocumentDataCoverLetterDto>
    | BaseScanDocumentDataDtoTypeMapping<"ENVELOPE", ScanDocumentDataEnvelopeDto>
    | BaseScanDocumentDataDtoTypeMapping<"ID_CARD", ScanDocumentDataIdCardDto>
    | BaseScanDocumentDataDtoTypeMapping<"OTHER", ScanDocumentDataOtherDto>
    | BaseScanDocumentDataDtoTypeMapping<"SALARY_STATEMENT", ScanDocumentDataSalaryStatementDto>
  );

export interface ScanDocumentDataEnvelopeDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  receiver?: ReceiverDto;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "ENVELOPE" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataIdCardDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "ID_CARD" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataOtherDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "OTHER" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDataSalaryStatementDto {
  archived: boolean;
  /** @format uuid */
  customerId: string;
  customerNumber: string;
  /** Id of a physical document. It is unique inside a stack BUT if the document was taken out of the store and will be reimported it may get the same documentId. */
  documentId: string;
  /**
   * The total number of pages in the document
   * @format int64
   */
  pageCount?: number;
  /** @format int64 */
  position: number;
  recordId: string;
  scanCode: string;
  /** @format date-time */
  scanDate: string;
  stackId: string;
  status: ScanStatusDto;
  /** @default "SALARY_STATEMENT" */
  type?: string;
  /** Vehicle identification number */
  vin?: string;
}

export interface ScanDocumentDetailDto {
  audit?: AuditInfoDto;
  data: ScanDocumentDataDto;
}

export interface ScanDocumentListDto {
  items?: ScanDocumentListItemDto[];
  /** @format int32 */
  totalPages?: number;
}

export interface ScanDocumentListItemDto {
  documentId?: string;
  /** Verfügbare Dokumentenarten */
  documentType?: DocumentTypeDto;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastModifiedDate: string;
  /** @format int64 */
  position?: number;
  recordId?: string;
  scanCode?: string;
  /** @format date-time */
  scanDate?: string;
  stackId?: string;
  status: ScanStatusDto;
  /** @format int64 */
  version: number;
  vin: string;
}

/** Columns available for sorting */
export enum ScanDocumentSortByDto {
  LAST_MODIFIED = "LAST_MODIFIED",
}

export enum ScanRecordStatusDto {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
}

export enum ScanStatusDto {
  IN_PROGRESS = "IN_PROGRESS",
  STACK_COMPLETE = "STACK_COMPLETE",
  COMPLETE = "COMPLETE",
  AMBIGUOUS_FIN = "AMBIGUOUS_FIN",
  NO_VIN = "NO_VIN",
  VIN_CHECK_DIGIT_MALFORMED = "VIN_CHECK_DIGIT_MALFORMED",
  NO_ENVELOPE = "NO_ENVELOPE",
  BAD_SCAN = "BAD_SCAN",
  REVOKED = "REVOKED",
}

export type ServiceEvent = BaseServiceEvent &
  (
    | BaseServiceEventTypeMapping<"SCAN_DOCUMENT", ScanDocumentApplicationEvent>
    | BaseServiceEventTypeMapping<"SCAN_DOCUMENT_ARCHIVED", ScanDocumentArchivedServiceEvent>
  );

/** The SortType */
export enum SortTypeDto {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

interface BaseScanDocumentCreateDto {
  type: string;
}

type BaseScanDocumentCreateDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

interface BaseScanDocumentDataDto {
  type: string;
}

type BaseScanDocumentDataDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

interface BaseServiceEvent {
  payload?: object;
  type: string;
}

type BaseServiceEventTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title S&E Adapter Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Sea<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scan
     * @name ListDocuments
     * @summary Returns a list of scan documents
     * @request GET:/api/v1/scan/document
     * @secure
     */
    listDocuments: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        /** Columns available for sorting */
        sortBy?: ScanDocumentSortByDto;
        /** The SortType */
        sortType?: SortTypeDto;
        q?: string;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @uniqueItems true */
        type?: DocumentTypeDto[];
        /** @uniqueItems true */
        status?: ScanStatusDto[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ScanDocumentListDto, any>({
        path: `/api/v1/scan/document`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scan
     * @name CreateScanDocument
     * @summary Creates a new scan document
     * @request POST:/api/v1/scan/document
     * @secure
     */
    createScanDocument: (
      data: {
        dto: ScanDocumentCreateDto;
        /** @format binary */
        scan: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/scan/document`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scan
     * @name ArchiveScanDocuments
     * @summary send orders to archive listed scan documents
     * @request POST:/api/v1/scan/document/batch/archive
     * @secure
     */
    archiveScanDocuments: (data: ScanDocumentArchiveBatchDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/scan/document/batch/archive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scan
     * @name ValidateScanDocument
     * @summary Validates scan document
     * @request POST:/api/v1/scan/document/validation
     * @secure
     */
    validateScanDocument: (data: ScanDocumentCreateDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/scan/document/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scan
     * @name GetDocumentScan
     * @summary Returns details of scan document
     * @request GET:/api/v1/scan/document/{id}
     * @secure
     */
    getDocumentScan: (id: string, params: RequestParams = {}) =>
      this.request<ScanDocumentDetailDto, any>({
        path: `/api/v1/scan/document/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
